import { render } from "./SliderPage.vue?vue&type=template&id=6458c6ea"
import script from "./SliderPage.vue?vue&type=script&lang=js"
export * from "./SliderPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__